export enum FilterType {
    SELECT = 'SELECT',
    SINGLE_SELECT = 'SINGLE_SELECT',
    DATE = 'DATE',
    NUMBER = 'NUMBER',
    SEARCH = 'SEARCH',
}

export interface IReportFilter {
    type: FilterType;
    column: string;
    label: string;
    required?: boolean;
    values?: IReportSelectFilterValue[];
    dateFilterPeriod?: string;
}

interface IReportSelectFilterValue {
    label: string;
    value: string;
}
